import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/layouts/default.vue").then(m => m.default || m)),
  "resume-print": defineAsyncComponent(() => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/layouts/resume-print.vue").then(m => m.default || m))
}